import Head from 'next/head'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import SevenImage from '~/assets/images/campaign-anniversary7/seven-hero.png'
import Footer from '~/components/Footer'
import Header from '~/components/Header'
import { useGA } from '~/hooks/useGA'
import { LOCALES } from '~/locales'
import {
  Hero,
  HeroSeven,
  HeroSubtitle,
  HeroTitle,
  Main,
  MainContent,
  PageInfo,
  PageInfoDivider,
  PageInfoItem,
  PageInfoLink,
  PrimaryButton,
  StyledPage,
} from './styled'

const Anniversary7 = () => {
  const { t, i18n } = useTranslation()
  const { trackClick } = useGA()
  const lang = i18n.resolvedLanguage === LOCALES.ZH ? 'zh-cn' : 'en-us'
  const ruleLink = `https://support.tokenlon.im/hc/${lang}/articles/52066467793172`

  const handleRuleLink = useCallback(() => {
    trackClick('webtl_7th_rule_link', { url: ruleLink })
  }, [ruleLink, trackClick])

  return (
    <StyledPage>
      <Head>
        <title>{t('anniversary7.meta_title')}</title>
        <meta name="description" content={t('anniversary7.meta_description')} />
      </Head>
      <Header />
      <Main>
        <MainContent>
          <Hero>
            <HeroSeven src={SevenImage.src} alt="Lucky 7" />
            <HeroTitle>{t('anniversary7.hero_title')}</HeroTitle>
            <HeroSubtitle>{t('anniversary7.hero_subtitle')}</HeroSubtitle>
            <PrimaryButton type="button" disabled>
              {t('anniversary7.activity_ended')}
            </PrimaryButton>
          </Hero>
        </MainContent>
        <PageInfo>
          <PageInfoLink
            href={ruleLink}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleRuleLink}
          >
            {t('anniversary7.activity_rules_link')}
          </PageInfoLink>
          <PageInfoDivider aria-hidden="true" />
          <PageInfoItem>{t('anniversary7.data_updated_through')}</PageInfoItem>
        </PageInfo>
      </Main>
      <Footer footerWrapperStyle={{ marginTop: 0 }} />
    </StyledPage>
  )
}

export default Anniversary7
